import { IconName } from '../../../../../Icon'
import { IconButton } from '../../../../../IconButton'
import { Tooltip } from '../../../../../Tooltip'

interface TableHoverActionProps {
  icon: IconName
  label: string
  onClick: () => void
}

export const TableHoverAction = ({ icon, label, onClick }: TableHoverActionProps) => {
  return (
    <Tooltip label={label} placement="bottom">
      <IconButton aria-label={label} icon={icon} onClick={onClick} variant="text" size="sm" />
    </Tooltip>
  )
}
